import { crv, cva } from '@/styled-system/css';

export const carouselScrollContainerStyles = cva({
  base: {
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    flexWrap: 'nowrap',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    scrollBehavior: 'smooth',
    _scrollbar: {
      display: 'none',
    },
    paddingBlockStart: 'tighter',
    paddingBlockEnd: 'default',
    _motionReduce: {
      scrollBehavior: 'auto',
    },
  },
  variants: {
    ...crv('enableSnap', {
      true: {
        scrollSnapType: 'x mandatory',
      },
      false: {
        scrollSnapType: 'none',
      },
    }),
    ...crv('scrollOffset', {
      none: {
        paddingInline: 'none',
        scrollPaddingInline: 'none',
      },
      xs: {
        paddingInline: 'tighter',
        scrollPaddingInline: 'tighter',
      },
      sm: {
        paddingInline: 'default',
        scrollPaddingInline: 'default',
      },
      md: {
        paddingInline: 'loose',
        scrollPaddingInline: 'loose',
      },
      lg: {
        paddingInline: 'looser',
        scrollPaddingInline: 'looser',
      },
      xl: {
        paddingInline: 'layout.looser',
        scrollPaddingInline: 'layout.looser',
      },
    }),
    ...crv('slideGap', {
      xxs: { gap: 'tightest' },
      xs: { gap: 'tighter' },
      sm: { gap: 'default' },
      md: { gap: 'loose' },
      lg: { gap: 'looser' },
      xl: { gap: 'layout.looser' },
    }),
  },
});
